/**
 * Relleno degradado para gráficas de línea "hero" -- inspirado en el
 * "Total Profit" de la referencia visual compartida (Shopeers). Se
 * centraliza acá para no repetir la misma config de gradient en cada
 * sección (users, memberships, chat, revision, preparation).
 */
export function buildGradientFill(colors: string[]) {
  return {
    colors,
    fill: {
      type: 'gradient',
      gradient: {
        type: 'vertical',
        shadeIntensity: 1,
        opacityFrom: 0.35,
        opacityTo: 0.05,
        stops: [0, 90, 100],
      },
    },
  };
}
